export default "__VITE_ASSET__DKvaN3Ld__"